module.exports = __webpack_public_path__ + "img/indethuisstudio@2x.0d28df57.png";